import {
    TIME_TRACKING_STOP,
    SAVE_READING_TIME_TRACKING_DATA,
    TIME_TRACKING_START,
    RESET_TIME_TRACKING_STATE,
    TIME_TRACKING_ADD_TO_START_TIME,
} from './timeTrackingActions';
import { TRO_PAGE_RECORDING } from './timeTrackingKeys';

const defaultState = {
    readingDuration: []
};

const timeTrackingReducer = (state = defaultState, action) => {
    const { type, timerKey, timestamp, milliseconds } = action;

    switch (type) {
    case TIME_TRACKING_START:
        return {
            ...state,
            [timerKey]: { ...state[timerKey], 'start': timestamp },
        };
    case TIME_TRACKING_STOP:
        if (timerKey === TRO_PAGE_RECORDING) {
            const { totalRecordingDuration = 0, start} = state[timerKey];
            return {
                ...state,
                [timerKey]: {
                    ...state[timerKey],
                    'stop': timestamp,
                    totalRecordingDuration: totalRecordingDuration + (timestamp - start) },
            };
        }
        return {
            ...state,
            [timerKey]: { ...state[timerKey], 'stop': timestamp },
        };
    case TIME_TRACKING_ADD_TO_START_TIME:
        return {
            ...state,
            [timerKey]: { ...state[timerKey], 'start': state[timerKey].start + milliseconds },
        };
    case SAVE_READING_TIME_TRACKING_DATA:
        return {
            ...state,
            readingDuration:
                [
                    ...state.readingDuration,
                    {
                        bookDuration: state[timerKey].stop - state[timerKey].start,
                    }
                ]
        };
    case RESET_TIME_TRACKING_STATE:
        return {
            ...state,
            [timerKey]: { start: null, stop: null, ...(timerKey === TRO_PAGE_RECORDING) && { totalRecordingDuration: null }},
        };
    default:
        return state;
    }
};

export default timeTrackingReducer;
